<script>
  import instance, {inicializa} from "./axios-control";
  import Portada from "./Portada.svelte";
  import Loading from "../../assets/src/Components/UI/Loading.svelte";

  let inicializado = false;
  inicializa().then(() => {
    inicializado = true;
  });

</script>

{#if inicializado}
    <Portada />
{:else}
    <Loading />
{/if}